var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_3_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0154 5.7824L32.5372 7.81568C35.4538 9.49958 36.6126 10.1888 37.4446 11.1128C38.2142 11.9675 38.7955 12.9744 39.1509 14.0682C39.5351 15.2507 39.5526 16.5989 39.5526 19.9667V24.0333C39.5526 27.4011 39.5351 28.7493 39.1509 29.9318C38.7955 31.0256 38.2142 32.0325 37.4446 32.8872C36.6126 33.8112 35.4538 34.5004 32.5372 36.1843L29.0154 38.2176C26.0988 39.9015 24.9225 40.5605 23.7063 40.819C22.5813 41.0581 21.4187 41.0581 20.2937 40.819C19.0775 40.5605 17.9012 39.9015 14.9846 38.2176L11.4628 36.1843C8.54625 34.5004 7.3874 33.8112 6.55539 32.8872C5.78583 32.0325 5.2045 31.0256 4.84911 29.9318C4.46487 28.7493 4.44744 27.4011 4.44744 24.0333V19.9667C4.44744 16.5989 4.46487 15.2507 4.84911 14.0682C5.2045 12.9744 5.78583 11.9675 6.55539 11.1128C7.3874 10.1888 8.54625 9.49958 11.4628 7.81568L14.9846 5.7824C17.9012 4.0985 19.0775 3.4395 20.2937 3.18098C21.4187 2.94186 22.5813 2.94186 23.7063 3.18098C24.9225 3.4395 26.0988 4.0985 29.0154 5.7824Z",
    stroke: "black",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6355 19.1931C27.7256 19.0958 27.7734 18.9667 27.7684 18.8342C27.7633 18.7017 27.7058 18.5766 27.6086 18.4865L26.54 17.4963C26.3375 17.3087 26.0211 17.3207 25.8334 17.5233L19.9851 23.8347L17.6203 21.2826C17.4326 21.0801 17.1162 21.068 16.9137 21.2557L15.8452 22.2459C15.7479 22.336 15.6904 22.4611 15.6854 22.5936C15.6803 22.7261 15.7281 22.8552 15.8182 22.9525L19.6183 27.0534C19.713 27.1555 19.8459 27.2136 19.9851 27.2136C20.1243 27.2136 20.2572 27.1555 20.3518 27.0534L27.6355 19.1931Z",
    fill: "#0A0B0D",
    stroke: "black",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_3_5",
    x: -7.2064,
    y: -8.6522,
    width: 58.4128,
    height: 61.3044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.07692
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_3_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_3_5",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.e3bb4a5ee0fabb64768ac6cbbb561ec4.svg";
export { ForwardRef as ReactComponent };